module.exports = __webpack_public_path__ + "static/result_suwon-f40ab23e7638c23354ec287a4ee81983.png";